import React, { useContext, useEffect } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { ThemeContext } from '../../../context/ThemeContext';
import { Add, Remove } from '@mui/icons-material';
import { Box, TextField } from '@mui/material';
import { amountMap, updateAmountMap } from '../../pages/Quotes';
import { setAmountForOneClick } from '../../../store/Slices/orderPositionSlice';
import { setAmountForSymbol } from '../../../store/Slices/amountSlice';

const AmountInput = ({ symbolId }) => {
    const symbolParameterData = useSelector((state) => state?.symbol?.allSymbolParams?.[symbolId], shallowEqual);
    const decimalPlaces = useSelector((state) => state.user.decimalPlacesForAmountFormatting);
    const { darkMode } = useContext(ThemeContext)
    const dispatch = useDispatch()
    const inputVal = useSelector((state) =>
        state?.amount?.[symbolId] ?? symbolParameterData?.minimumAmountPerDeal ?? 0.01
    );

    const decreaseAmount = (e) => {
        e.stopPropagation();
        const step = symbolParameterData?.minimumAmountPerDeal || 0.1;
        const currentAmount = inputVal;
        const newAmount = parseFloat(currentAmount) - step;
        const validAmount = newAmount > 0 ? newAmount.toFixed(decimalPlaces) : currentAmount;

        updateAmountMap(symbolId, validAmount);
        dispatch(setAmountForOneClick(parseFloat(validAmount)));
        dispatch(setAmountForSymbol({ symbolId, amount: parseFloat(validAmount) }));
    };

    const increaseAmount = (e) => {
        e.stopPropagation();
        const step = symbolParameterData?.minimumAmountPerDeal || 0.1;
        const currentAmount = inputVal;
        const newAmount = (parseFloat(currentAmount) + step).toFixed(decimalPlaces);

        updateAmountMap(symbolId, newAmount);
        dispatch(setAmountForOneClick(parseFloat(newAmount)));
        dispatch(setAmountForSymbol({ symbolId, amount: parseFloat(newAmount) }));
    };

    const handleChange = (e) => {
        const value = e.target.value
        if (value > symbolParameterData?.minimumAmountPerDeal && value < symbolParameterData?.maximumAmountPerDeal) {
            dispatch(setAmountForSymbol({ symbolId, amount: parseFloat(value) }));
        } else {
            dispatch(setAmountForSymbol({ symbolId, amount: parseFloat(value) }));
        }
    }

    const updatemap = (e) => {
        const value = e.target.value
        if (value > symbolParameterData?.minimumAmountPerDeal && value < symbolParameterData?.maximumAmountPerDeal) {
            const newVal = Math.round(value / symbolParameterData?.minimumAmountPerDeal) * symbolParameterData?.minimumAmountPerDeal
            dispatch(setAmountForSymbol({ symbolId, amount: parseFloat(newVal.toFixed(decimalPlaces)) }));
        } else {
            if (value < symbolParameterData?.minimumAmountPerDeal) {
                dispatch(setAmountForSymbol({ symbolId, amount: symbolParameterData?.minimumAmountPerDeal }));
            } else if (value > symbolParameterData?.maximumAmountPerDeal) {
                dispatch(setAmountForSymbol({ symbolId, amount: symbolParameterData?.maximumAmountPerDeal }));
            } else {
                dispatch(setAmountForSymbol({ symbolId, amount: parseFloat(value) }));
            }
        }
    }

    return (
        <Box sx={{ marginTop: '1px', px: 1, display: "flex", justifyContent: 'center', alignItems: "center", width: 110, height: '25px', backgroundColor: darkMode ? '#2e3338' : 'var(--white)', p: 1, border: `1px solid ${darkMode ? "var(--borderDark)" : 'var(--borderLight)'} ` }} onClick={(e) => { e.stopPropagation(); }} onDoubleClick={(e) => { e.stopPropagation(); }}>
            <Remove sx={{ cursor: 'pointer', fontSize: '16px', color: darkMode ? 'white' : "gray" }} onClick={decreaseAmount} />
            <TextField value={inputVal} variant="filled" type='number' onChange={handleChange}
                InputProps={{
                    disableUnderline: true,
                    inputProps: {
                        min: symbolParameterData?.minimumAmountPerDeal,
                        max: symbolParameterData?.maximumAmountPerDeal,
                        step: symbolParameterData?.minimumAmountPerDeal
                    }
                }}
                onBlur={updatemap}
                sx={{ '& .MuiFilledInput-root': { backgroundColor: 'transparent', fontSize: '13px', }, '& .MuiFilledInput-input': { padding: 0, px: 1, borderRadius: 0, textAlign: "center", backgroundColor: 'transparent', '&:focus': { backgroundColor: 'transparent' } } }}
            />
            <Add sx={{ cursor: 'pointer', fontSize: '16px', color: darkMode ? 'white' : "gray" }} onClick={increaseAmount} />
        </Box>
    )
}

export default AmountInput